





































import _ from 'underscore';
import { Component, Prop, Vue } from 'vue-property-decorator';
import axiosInstance from '../axiosInstance';

const REJECTED = 'Rejected';
const APPROVED = 'Approved';

interface ApprovalVersion {
  revisionId: string;
  s3Version: string;
  revisionSummary: string;
}

interface ApprovalDetails {
  pipelineName: string;
  // ...
}

interface Approval {
  version: ApprovalVersion;
  pipelineNameStageAction: string;
  approval: ApprovalDetails;
  disposition?: string;
}

@Component
export default class HelloWorld extends Vue {
  approvals = [];

  @Prop() private msg!: string;
  
  async fetchApprovals() {
    const approvals = await axiosInstance.get('approvals');
    console.log('approvals', approvals);
    this.approvals = approvals.data;
  }

  async approve(pipelineNameStageAction: string) {
    console.log('approving - ', pipelineNameStageAction);
    const response = await axiosInstance.post(`approvals/${pipelineNameStageAction}/approve`);
    console.log('response', response);
    this.setDisposition(pipelineNameStageAction, APPROVED);
    return;
  }

  async reject(pipelineNameStageAction: string) {
    console.log('rejecting - ', pipelineNameStageAction);
    const response = await axiosInstance.post(`approvals/${pipelineNameStageAction}/reject`);
    console.log('response', response);
    this.setDisposition(pipelineNameStageAction, REJECTED);
    return;
  }

  setDisposition (pipelineNameStageAction: string, disposition: string) {
    const approval = _.findWhere(this.approvals, { pipelineNameStageAction: pipelineNameStageAction });
    if (!approval) { return; }
    Vue.set(approval, 'disposition', disposition);
  }

  get prodApprovals(): Array<Approval> {
    return this.approvals.filter((item: Approval): boolean => item.approval.pipelineName.toLowerCase().includes('prod'));
  }

  get nonProdApprovals(): Array<Approval> {
    return this.approvals.filter((item: Approval): boolean => !item.approval.pipelineName.toLowerCase().includes('prod'));
  }

  mounted () {
    this.fetchApprovals();
  }
}
